module.exports = __webpack_public_path__ + "media/icons/mail@2x-2513ae2c.png";